import {
	Card,
	CardBody,
	Input,
	TableRow,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
} from '@windmill/react-ui';
import ExportData from 'components/common/ExportData';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useEffect, useContext } from 'react';
import SeoManageCityServices from 'services/SeoManageCityServices';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import SeoManageCityTable from 'components/seoManageCity/SeoManageCityTable';
import sidebar from 'routes/sidebar';
import { FiRefreshCcw } from 'react-icons/fi';
import { SidebarContext } from 'context/SidebarContext';

const SeoManageCity = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { title, serviceId } = useToggleDrawer();
	const { data, loading, error } = useAsync(
		SeoManageCityServices.getAllSeoCity
	);
	const [status, setStatus] = useState('');
	const { setIsUpdate } = useContext(SidebarContext);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const {
		SeoManageCityRef,
		dataTable,
		serviceData,
		handleSubmitSeoManageCity,
		currentPage,
	} = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);

	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	const updatedData = data?.data?.map((item) => {
		const { id, ...rest } = item;
		return rest;
	});

	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);

	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'manage city' && perm.view === 1
		  );

	const hideEdit = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'manage city' && perm.edit === 1
		  );

	const hideExport = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'manage city' && perm.export === 1
		  );

	const handleRefresh = () => {
		setIsUpdate(true);
	};
	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />
					<PageTitle sidebar={sidebar().sidebar} />
					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										ref={SeoManageCityRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										placeholder="Quick Search"
										onChange={handleSubmitSeoManageCity}
									/>
								</div>

								{!hideExport && (
									<ExportData
										exportData={updatedData}
										fileNames="Seo Manage City"
									/>
								)}

								<FiRefreshCcw
									onClick={() => {
										handleRefresh();
									}}
									cursor="pointer"
								/>
							</div>
						</CardBody>
					</Card>
					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer>
								<div
									className="overflow-y-scroll "
									style={{ maxHeight: '65vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="capitalize text-center sticky top-0 z-10 text-sm">
											<TableRow>
												<TableCell>Sl.No.</TableCell>
												<TableCell>City</TableCell>
												<TableCell>State</TableCell>
												<TableCell>Country</TableCell>
												<TableCell>Action</TableCell>
												<TableCell>Status</TableCell>
											</TableRow>
										</TableHeader>
										<SeoManageCityTable
											hourRentalBasicRate={dataTable}
											perpage={itemsPerPage}
											currentPage={currentPage}
											hideEdit={hideEdit}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<NotFound title="There are no Manage Cities." />
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default SeoManageCity;
